export default "__VITE_ASSET__e5e51152__"